import { render } from "./PaymentListBlock.vue?vue&type=template&id=656f8585"
import script from "./PaymentListBlock.vue?vue&type=script&lang=js"
export * from "./PaymentListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__